import { render } from "./AppSkills.vue?vue&type=template&id=61b6d59f&scoped=true"
import script from "./AppSkills.vue?vue&type=script&lang=js"
export * from "./AppSkills.vue?vue&type=script&lang=js"

import "./AppSkills.vue?vue&type=style&index=0&id=61b6d59f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b6d59f"]])

export default __exports__